import React from "react";
import getAvatarUrl from "../../../utils/get-avatar-url";
import ToggleLinksInput from "../../../parts/inputs/toggle-links-input";
import moment from "moment";
import submit from "submit-form";
import {
  PROGRAMMING,
  COMMENTARY,
  VIDEO,
  OTHER,
  CHECKIN,
} from "./task-constants";
import { getRoleNameById } from "../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";

import TablistNav from "../../../parts/inputs/TablistNav";
import ChooseCoach from "../../dashboard/settings/manage-coaches/ChooseCoach";
import SvgIcon from "../../../parts/SvgIcon";
import EmptyTasks from "./components/EmptyTasks";

const showDueDate = (taskDate) => {
  const today = moment.utc().startOf("day");
  const yesterday = today.clone().subtract(1, "d");
  const tomorrow = today.clone().add(1, "d");
  const isToday = taskDate.isSame(today, "d");
  const isYesterday = taskDate.isSame(yesterday, "d");
  const isTomorrow = taskDate.isSame(tomorrow, "d");
  return (
    <span>
      {isToday && "Today"}
      {isYesterday && "Yesterday"}
      {isTomorrow && "Tomorrow"}
      {!isToday && !isYesterday && !isTomorrow && taskDate.fromNow()}
    </span>
  );
};

const showTaskList = (
  tasks,
  currentTab,
  handleSelectTask,
  selectedTasks,
  organizationCoach,
  isAllowToViewAllOrganizationsCoaches,
  activeUserId
) => {
  return tasks.map((task) => {
    const taskDate = moment.utc(task.date).startOf("day");
    const isSelected = selectedTasks.includes(task._id);

    const organizationCoachParam = organizationCoach
      ? `&organizationCoach=${organizationCoach}`
      : isAllowToViewAllOrganizationsCoaches &&
        task.user &&
        task.user !== activeUserId
      ? `&organizationCoach=${task.user}`
      : "";

    const checkInComment = task.description.includes("check-in");

    return (
      <tr className="task task-individual" key={task._id}>
        <td className="col select-col">
          <SvgIcon
            onClickFn={(e) => handleSelectTask(e, task._id)}
            src={
              isSelected
                ? "/img/new-icons/checked-square.svg"
                : "/img/new-icons/unchecked-square.svg"
            }
            noFilterOnLight={isSelected}
          />
        </td>
        <td className="col name">
          {task.athleteInfo && (
            <a
              href={`/athlete-portal/calendar/?athlete=${task.athleteInfo._id}${organizationCoachParam}`}
              className="image"
            >
              <img
                src={getAvatarUrl(task.athleteInfo)}
                loading="lazy"
                className="profile-picture w-8 h-8 rounded-full mr-2"
              />
              {task.athleteInfo.name}
            </a>
          )}
        </td>
        <td className="col description">{task.description}</td>

        <td className="col date">
          {(currentTab === VIDEO ||
            currentTab === COMMENTARY ||
            currentTab === CHECKIN) &&
            task.athleteInfo && (
              <div className="flex gap-2 items-center">
                <span>{showDueDate(taskDate)}</span>
                <a
                  href={
                    currentTab === CHECKIN || checkInComment
                      ? `/athlete-portal/metrics/check-in-summary?athlete=${
                          task.athleteInfo._id
                        }&checkInDate=${taskDate
                          .clone()
                          .format("YYYY-MM-DD")}&navFrom=tasks` +
                        organizationCoachParam
                      : `/athlete-portal/calendar/?athlete=${
                          task.athleteInfo._id
                        }&view=day&date=${taskDate
                          .clone()
                          .format("YYYY-MM-DD")}` + organizationCoachParam
                  }
                  role="button"
                  data-button-type="outline"
                  cl
                >
                  <span>View</span>
                </a>
              </div>
            )}
          {(currentTab === PROGRAMMING ||
            currentTab === OTHER ||
            !task.athleteInfo) &&
            showDueDate(taskDate)}
        </td>
        {currentTab === VIDEO && (
          <td className="video-task-col-content">
            {task.video && (
              <span className="video">
                <a
                  className="task-video"
                  href={`/actions/refresh?modal[type]=exercise-set-video&mediaId=${task.video.videoId}&originalId=${task.video.videoOriginal}&athleteId=${task.athlete}&uploaderId=${task.video.uploaderId}`}
                >
                  <SvgIcon src="/img/new-icons/play-with-gradient.svg" />
                </a>
              </span>
            )}
          </td>
        )}
        <td className="col edit-col">
          <a
            role="button"
            data-button-type="secondary"
            data-icon
            href={
              organizationCoach
                ? `/coaching-portal/tasks/?modal[type]=edit-task&id=${task._id}&tab=${task.type}&organizationCoach=${organizationCoach}`
                : `/coaching-portal/tasks/?modal[type]=edit-task&id=${task._id}&tab=${task.type}`
            }
            className="w-fit"
          >
            <SvgIcon src="/img/new-icons/edit-pencil.svg" alt="Edit Task" />
          </a>
        </td>
      </tr>
    );
  });
};

class View extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedTasks: [],
      screenHeight: this.isBrowser() ? window.innerHeight : null,
      remSize: this.isBrowser() ? this.getRemSize() : null,
    };
    this.handleSelectTask = this.handleSelectTask.bind(this);
    this.handleDeselectAll = this.handleDeselectAll.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleMarkCompleted = this.handleMarkCompleted.bind(this);
    this.selectOrganizationCoach = this.selectOrganizationCoach.bind(this);
  }
  componentDidMount() {
    if (this.isBrowser()) {
      window.addEventListener("resize", this.handleResize);
    }
  }

  componentWillUnmount() {
    if (this.isBrowser()) {
      window.removeEventListener("resize", this.handleResize);
    }
  }

  handleResize = () => {
    this.setState({
      screenHeight: window.innerHeight,
    });
    this.updateRemSize();
  };
  componentDidUpdate(prevProps) {
    const { completed, tab } = this.props.query;
    if (
      prevProps.query.completed !== completed ||
      prevProps.query.tab !== tab
    ) {
      this.handleDeselectAll();
    }
  }

  handleSelectTask(e, id) {
    e.preventDefault();
    const selectedTasks = this.state.selectedTasks.slice();
    if (selectedTasks.indexOf(id) > -1) {
      selectedTasks.splice(selectedTasks.indexOf(id), 1);
    } else {
      selectedTasks.push(id);
    }

    this.setState({ selectedTasks });
  }

  handleDeselectAll(e) {
    if (e) e.preventDefault();
    this.setState({ selectedTasks: [] });
  }

  handleSelectAll(e) {
    e.preventDefault();
    const { tasks } = this.context.locals;
    const selectedTasks = [];

    tasks.thisWeek.forEach((task) => {
      selectedTasks.push(task._id);
    });
    tasks.upcoming.forEach((task) => {
      selectedTasks.push(task._id);
    });

    this.setState({ selectedTasks });
  }

  handleMarkCompleted(e) {
    e.preventDefault();
    const { selectedTasks } = this.state;
    const { tab } = this.props.query;
    submit(`/coaching-portal/tasks/complete`, {
      method: "POST",
      body: {
        tasks: selectedTasks,
        tab,
      },
    });
    this.handleDeselectAll();
  }
  selectOrganizationCoach(e, coach) {
    e.stopPropagation();
    e.preventDefault();

    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        organizationCoach: coach._id,
        filterGroup: "",
      },
    });
  }
  isBrowser() {
    return typeof window !== "undefined";
  }
  getRemSize() {
    // Get the computed value of 1rem in pixels
    const computedRem = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    return computedRem;
  }
  updateRemSize() {
    this.setState({
      remSize: this.getRemSize(),
    });
  }
  render() {
    const { locals } = this.context;
    const { selectedTasks, screenHeight, remSize } = this.state;

    const {
      query,
      tasks,
      activeUser,
      activeUserToRequest,
      organizationRoles = [],
      usersOrganization = {
        organizationActiveUsers: [],
      },
      coachOrganizationInformation,
    } = locals;
    const activeUserId = activeUser._id;
    const { organizationActiveUsers = [] } = usersOrganization;
    const organizationCoach = query.organizationCoach || undefined;
    const { athletesGroups } = coachOrganizationInformation ?? activeUser;
    const tab = query.tab || PROGRAMMING;
    const completed = query.completed || false;
    const { thisWeek, upcoming } = tasks;
    const thisWeekLength = thisWeek && thisWeek.length;
    const upcomingLength = upcoming && upcoming.length;
    const referAsClients = Boolean(activeUser.referAsClients);
    //Get the name of the organization's role of the current user
    const organizationRoleName = !!activeUser.organizationRoleId
      ? getRoleNameById(organizationRoles, activeUser.organizationRoleId)
      : "Coach";
    //The user is allow to see al the athletes of the coaches
    const isAllowToViewAllOrganizationsCoaches =
      organizationRoleName === "Owner" || organizationRoleName === "Admin";

    const athletesArrayGroups = athletesGroups || [];

    const clientWord = referAsClients ? "Clients" : "Athletes";

    const groupOptions = isAllowToViewAllOrganizationsCoaches
      ? [
          {
            text: `All ${clientWord}`,
            value: "all",
          },
          {
            text: `All Organization ${clientWord}`,
            value: "organization",
            href: `/actions/refresh?tab=${tab}&filterGroup=organization`,
          },
        ]
      : [
          {
            text: `All ${clientWord}`,
            value: "all",
          },
        ];

    const sizeOfTable = screenHeight - (270 + 44 + 98) * (remSize / 16);
    const totalRows = Math.floor(sizeOfTable / (3 * remSize));
    const emptyRows =
      totalRows - thisWeek.length - upcoming.length > 0
        ? new Array(totalRows - thisWeek.length - upcoming.length).fill(null)
        : [];

    return (
      <main className="coaching-tasks">
        <header>
          <TablistNav
            name="tab"
            options={[
              {
                text: "Programs",
                value: PROGRAMMING,
                href: organizationCoach
                  ? `/coaching-portal/tasks?tab=${PROGRAMMING}&completed=${completed}&organizationCoach=${organizationCoach}`
                  : `/coaching-portal/tasks?tab=${PROGRAMMING}&completed=${completed}`,
              },
              {
                text: "Videos",
                value: VIDEO,
                href: organizationCoach
                  ? `/coaching-portal/tasks?tab=${VIDEO}&completed=${completed}&organizationCoach=${organizationCoach}`
                  : `/coaching-portal/tasks?tab=${VIDEO}&completed=${completed}`,
              },
              {
                text: "Comments",
                value: COMMENTARY,
                href: organizationCoach
                  ? `/coaching-portal/tasks?tab=${COMMENTARY}&completed=${completed}&organizationCoach=${organizationCoach}`
                  : `/coaching-portal/tasks?tab=${COMMENTARY}&completed=${completed}`,
              },
              {
                text: "Check-Ins",
                value: CHECKIN,
                href: organizationCoach
                  ? `/coaching-portal/tasks?tab=${CHECKIN}&completed=${completed}&organizationCoach=${organizationCoach}`
                  : `/coaching-portal/tasks?tab=${CHECKIN}&completed=${completed}`,
              },
              {
                text: "Other",
                value: OTHER,
                href: organizationCoach
                  ? `/coaching-portal/tasks?tab=${OTHER}&completed=${completed}&organizationCoach=${organizationCoach}`
                  : `/coaching-portal/tasks?tab=${OTHER}&completed=${completed}`,
              },
            ]}
          />
          <div role="buttons-container">
            {isAllowToViewAllOrganizationsCoaches && (
              <ChooseCoach
                activeUser={activeUser}
                organizationActiveUsers={organizationActiveUsers}
                isFrom="list"
                selectedCoach={
                  organizationActiveUsers.find(
                    (obj) =>
                      obj._id.toString() === query.organizationCoach?.toString()
                  ) || organizationActiveUsers[0]
                }
                onSelectCoach={this.selectOrganizationCoach}
              />
            )}
            <a
              role="button"
              data-button-type="outline"
              disabled={selectedTasks.length > 0}
              href={
                organizationCoach
                  ? `/coaching-portal/tasks/?tab=${tab}&completed=${!completed}&organizationCoach=${organizationCoach}`
                  : `/coaching-portal/tasks/?tab=${tab}&completed=${!completed}`
              }
            >
              <span>{completed ? "Show not completed" : "Show completed"}</span>
            </a>
            <a
              role="button"
              data-button-type="primary"
              href={
                organizationCoach
                  ? `/coaching-portal/tasks/?modal[type]=add-task&tab=${tab}&organizationCoach=${organizationCoach}`
                  : `/coaching-portal/tasks/?modal[type]=add-task&tab=${tab}`
              }
              disabled={selectedTasks.length > 0}
            >
              Add Task
            </a>
          </div>
        </header>

        <section>
          <div className="athletes-groups-wrapper">
            <div>
              {thisWeekLength > 0 && (
                <div className="chip info">This week ({thisWeekLength})</div>
              )}
              {((athletesArrayGroups && athletesArrayGroups.length > 0) ||
                isAllowToViewAllOrganizationsCoaches) && (
                <ToggleLinksInput
                  name="filterGroup"
                  options={[
                    ...groupOptions,
                    ...athletesArrayGroups.map((athleteGroup) => ({
                      text: athleteGroup.name,
                      value: athleteGroup.name,
                    })),
                  ]}
                />
              )}
            </div>
            {selectedTasks.length > 0 && (
              <a
                role="button"
                data-button-type="primary"
                className="complete-tasks"
                onClick={this.handleMarkCompleted}
              >
                {`Mark as${completed ? " not " : " "}complete`}
              </a>
            )}
          </div>

          {/* select and deselect all */}
          {thisWeekLength > 0 || upcomingLength > 0 ? (
            <section role="table-wrapper" data-borders-inside>
              <table role="report-table">
                <thead>
                  <tr className="task-description">
                    <th className="col select-col">
                      {(thisWeekLength > 0 || upcomingLength > 0) && (
                        <SvgIcon
                          src={
                            selectedTasks.length ===
                            thisWeekLength + upcomingLength
                              ? "/img/new-icons/checked-square.svg"
                              : "/img/new-icons/unchecked-square.svg"
                          }
                          onClickFn={
                            selectedTasks.length ===
                            thisWeekLength + upcomingLength
                              ? this.handleDeselectAll
                              : this.handleSelectAll
                          }
                          noFilterOnLight={
                            selectedTasks.length ===
                            thisWeekLength + upcomingLength
                          }
                        />
                      )}
                    </th>

                    <th className="col name">
                      {referAsClients ? "Client" : "Athlete"}
                    </th>
                    <th className="col description">Tasks</th>

                    <th className="col date">
                      {tab === VIDEO || tab === COMMENTARY
                        ? "Workout date"
                        : tab === CHECKIN
                        ? "Check-In date"
                        : "Due date"}
                    </th>
                    {tab === VIDEO && (
                      <th className="video-task-col">Videos</th>
                    )}
                    <th className="col edit-col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {showTaskList(
                    thisWeek,
                    tab,
                    this.handleSelectTask,
                    selectedTasks,
                    organizationCoach,
                    screenHeight,
                    isAllowToViewAllOrganizationsCoaches,
                    activeUserId
                  )}
                  {upcomingLength > 0 && (
                    <div className="list-title upcoming-task">
                      Upcoming ({upcomingLength})
                    </div>
                  )}
                  {showTaskList(
                    upcoming,
                    tab,
                    this.handleSelectTask,
                    selectedTasks,
                    organizationCoach,
                    screenHeight,
                    isAllowToViewAllOrganizationsCoaches,
                    activeUserId
                  )}
                  {emptyRows.map((item) => (
                    <tr>
                      <td>
                        <div className="h-8"></div>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      {tab === VIDEO && <td></td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          ) : (
            <EmptyTasks
              tab={tab}
              organizationCoach={organizationCoach}
              selectedTasks={selectedTasks}
              referAsClients={referAsClients}
            />
          )}
        </section>
      </main>
    );
  }
}

export default View;
